import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { problemDetailCode, toFormError } from '@rms/core/error';
import { AppError } from '@rms/sdk/errors';
import { catchError, Observable, throwError } from 'rxjs';

import { UserEmailInUseError } from '../errors';
import { PasswordChangeRequest, USER_ERROR_CODE, UserProfile, UserProfileUpdateRequest } from '../models';
import { UserApiService } from './user-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly api = inject(UserApiService);

  public getProfile(userId: string): Observable<UserProfile> {
    return this.api
      .getUser(userId)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => AppError.from(error, 'profile.errors.load'))));
  }

  public updateProfile(userId: string, request: UserProfileUpdateRequest): Observable<UserProfile> {
    return this.api
      .updateUser(userId, request)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          throwError(() =>
            problemDetailCode(error) === USER_ERROR_CODE.EMAIL_ALREADY_IN_USE
              ? new UserEmailInUseError(error)
              : toFormError(error, 'profile.errors.update')
          )
        )
      );
  }

  public changePassword(request: PasswordChangeRequest): Observable<void> {
    return this.api
      .changePassword(request)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => toFormError(error, 'profile.errors.password'))));
  }
}
